const RUNTIME_CONFIG_TIMEOUT = 3000;

const fetchRuntimeConfig = () =>
  new Promise((resolve) => {
    const bffPath = window?.baseAppConfig?.bffPath;
    if (!bffPath || window.Cypress) {
      resolve();
      return;
    }

    const configUrl = `${bffPath}/runtime-config`;
    const timeout = setTimeout(resolve, RUNTIME_CONFIG_TIMEOUT);

    const script = window.document.createElement('script');
    script.src = configUrl;
    script.onload = script.onerror = () => {
      clearTimeout(timeout);
      resolve();
    };
    window.document.head.appendChild(script);
  });

export default fetchRuntimeConfig;
